/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Entrysignuphint2Inputs */

const en_entrysignuphint2 = /** @type {(inputs: Entrysignuphint2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`With seats and questions`)
};

const de_entrysignuphint2 = /** @type {(inputs: Entrysignuphint2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mit Plätzen und Fragen`)
};

/**
* | output |
* | --- |
* | "With seats and questions" |
*
* @param {Entrysignuphint2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const entrysignuphint2 = /** @type {((inputs?: Entrysignuphint2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Entrysignuphint2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_entrysignuphint2(inputs)
	return de_entrysignuphint2(inputs)
});
export { entrysignuphint2 as "entrySignupHint" }